import React, { type InputHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import WebLinkTooltip from "src/shared/forms/tooltips/WebLinkTooltip";
import { length as Length } from "src/shared/forms/validations/Length";
import WebLink from "src/shared/forms/validations/WebLink";

const MIN_MERCHANT_GROUP_WEBSITE_CHARS: number | undefined = 3;
const MAX_MERCHANT_GROUP_WEBSITE_CHARS: number | undefined = 128;
const LengthValidation = Length(
  MIN_MERCHANT_GROUP_WEBSITE_CHARS,
  MAX_MERCHANT_GROUP_WEBSITE_CHARS,
);

export interface IMerchantGroupWebsiteInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {}

export default ({
  inputID,
  label = <FormattedMessage id="contacts.website" />,
  validationDisabled = false,
  tooltip = <WebLinkTooltip />,
  ...rest
}: IMerchantGroupWebsiteInputProps) => {
  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      tooltip={tooltip}
      validate={!validationDisabled ? [WebLink, LengthValidation] : undefined}
      {...rest}
    />
  );
};
